const generateNewCollection = (data: CollectionItem) => {
    return {
        collectionId: (data && data.collectionId && data.collectionId.toString()) || '',
        name: data.name,
        description: data.description,
        criteriaCount: 0,
        criteria: {
            datasets: [],
            bundles: [],
            solutions: [],
            blueprints: []
        },
        createdDate: data.createdDate
    };
};

const convertToCamelcase = (data: PascalCollection[]) => {
    const toCriteria = (c: any) => ({
        datasets: (c && (c.Datasets || c.datasets)) || [],
        bundles: (c && (c.Bundles || c.bundles)) || [],
        solutions: (c && (c.Solutions || c.solutions)) || [],
        blueprints: (c && (c.Blueprints || c.blueprints)) || [],
    });

    const toItem = (item: any) => ({
        collectionId: item.CollectionId || item.collectionId || '',
        name: item.Name || item.name || '',
        description: item.Description || item.description || '',
        criteriaCount: item.CriteriaCount || item.criteriaCount || 0,
        criteria: toCriteria((item.Criteria || item.criteria) || {}),
        createdDate: item.CreatedDate || item.createdDate,
    });

    return Array.isArray(data) ? (data as PascalCollection[]).map(toItem) : toItem(data as PascalCollection);
};

export { generateNewCollection, convertToCamelcase };
